import api from "./Api";

class CompraDFeManifestoUltimaConsultaService {
  GetCompraDFeManifestoUltimaConsulta(payload) {
    return api
      .get("/v1/compraDFeManifestoUltimaConsulta/" + payload)
      .then((response) => {
        return response.data;
      });
  }

  PostCompraDFeManifestoUltimaConsulta(payload) {
    return api
      .post("/v1/compraDFeManifestoUltimaConsulta/", payload)
      .then((response) => {
        return response.data;
      });
  }

  PutCompraDFeManifestoUltimaConsulta(payload) {
    return api
      .put("/v1/compraDFeManifestoUltimaConsulta/", payload)
      .then((response) => {
        return response.data;
      });
  }

  DeleteCompraDFeManifestoUltimaConsulta(payload) {
    return api
      .delete("/v1/compraDFeManifestoUltimaConsulta/" + payload)
      .then((response) => {
        return response.data;
      });
  }

  GetCompraDFeManifestoUltimaConsultaOData(payload) {
    return api
      .get("/OData/compraDFeManifestoUltimaConsulta" + payload)
      .then((response) => {
        return response.data;
      });
  }
}

export default new CompraDFeManifestoUltimaConsultaService();
